












































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import * as calc from '@/app/order-calculations-interface';
import Order from './Order.vue';
import { GQL_order_order, GQL_order_order_orderAllowanceCharges } from '@/queries/__generated__/order';
import { WatchObjectAsJson } from '@/decorators/watch-object-as-json';
import Decimal from '@/utils/decimal';

@Component
export default class OrderAllowanceCharge extends Vue {
  @Prop(Object) public order!: GQL_order_order;
  @Prop(Object) public allowanceCharge!: GQL_order_order_orderAllowanceCharges;
  @Prop(String) public label!: string;
  @Prop(Boolean) public isPositive!: boolean
  @Inject() public documentComponent!: Order;

  get editable() {
    return this.documentComponent.reactiveProps.editable;
  }

  @WatchObjectAsJson('order.orderLines')
  @WatchObjectAsJson('allowanceCharge')
  public calculate() {
    const newLines = calc.orderAllowanceChargeLineAmounts(
      this.order as unknown as calc.IOrder,
      this.allowanceCharge as unknown as calc.IOrderAllowanceCharge,
    );

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const existingLines = (this.allowanceCharge.orderAllowanceChargeLines as any[]);

    existingLines.forEach(line => {
      const updatedLine = newLines.find(l => l.vatRateSymbol === line.vatRateSymbol);

      if (updatedLine) {
        delete line._destroy;
        line.amount = updatedLine.amount;
        line.baseAmount = updatedLine.baseAmount;
        line.vatRateSymbol = updatedLine.vatRateSymbol;
      } else {
        Vue.set(line, '_destroy', true);
      }
    });

    newLines.forEach(newLine => {
      const line = existingLines.find(l => l.vatRateSymbol === newLine.vatRateSymbol);

      if (!line) {
        existingLines.push({ id: null, ...newLine });
      }
    });

    // remove empty lines
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const emptyLineIndex = existingLines.findIndex(line => !line.id && line._destroy);
      if (emptyLineIndex === -1) break;

      existingLines.splice(emptyLineIndex, 1);
    }
  }

  public get amount() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (this.allowanceCharge.orderAllowanceChargeLines as any[])
      .filter(line => !line._destroy)
      .reduce((sum, line) => sum.add(line.amount), new Decimal(0));
  }
}
